const PREMIUM_FEATURES_PREFIX = 'premium-features'
const SUBSCRIPTIONS_PAGE = 'subscriptions-page'
const FEATURE_CARD = 'feature-card'

export const SubscriptionsPageIds = {
  CustomerPortal: `${PREMIUM_FEATURES_PREFIX}__${SUBSCRIPTIONS_PAGE}__customer-portal`,
} as const

export const FeatureCardIds = {
  Card: `${PREMIUM_FEATURES_PREFIX}__${FEATURE_CARD}__card`,
  Status: `${PREMIUM_FEATURES_PREFIX}__${FEATURE_CARD}__status`,
  OpenFreeTrialText: `${PREMIUM_FEATURES_PREFIX}__${FEATURE_CARD}__open-free-trial-text`,
  ManageBillingLink: `${PREMIUM_FEATURES_PREFIX}__${FEATURE_CARD}__manage-billing-link`,
  PurchaseButton: `${PREMIUM_FEATURES_PREFIX}__${FEATURE_CARD}__purchase-button`,
}
